<template>
  <div class="max-w-[90vw] mx-auto pb-12">
    <!-- Header -->
    <div class="w-full flex justify-between items-center mt-4 mb-6">
      <v-container class="onest-font pl-0">
        <a
          @click.prevent="voltar"
          style="color: inherit; cursor: pointer; text-decoration: none"
          class="d-flex align-center d-inline-flex"
        >
          <v-icon size="20" class="mr-1">mdi-arrow-u-left-bottom</v-icon>
          <span style="text-decoration: underline">voltar</span>
        </a>
        <h1 class="font-bold mt-2 text-5xl">{{ tituloPagina }}</h1>
      </v-container>

      <v-container class="onest-font d-flex justify-end gap-2 pr-0">
        <v-btn
          v-if="isVisualizar"
          @click="alternarParaEdicao"
          :disabled="carregando || salvando"
          variant="flat"
          prepend-icon="mdi-pencil"
          color="primary"
        >
          Editar Formulário
        </v-btn>

        <v-btn
          v-if="!isVisualizar"
          @click="salvar"
          :disabled="carregando || salvando"
          :loading="salvando"
          variant="flat"
          prepend-icon="mdi-content-save"
          color="primary"
        >
          Salvar formulário
        </v-btn>
      </v-container>
    </div>

    <!-- Loading State -->
    <div v-if="carregando" class="py-12 text-center text-gray-500 font-medium">
      <v-progress-circular
        indeterminate
        color="primary"
        class="mb-4"
      ></v-progress-circular>
      <p>Carregando dados do formulário...</p>
    </div>

    <div v-else class="w-full flex flex-col gap-6 max-w-5xl mx-auto">
      <v-alert
        v-if="mensagemErro"
        type="error"
        closable
        @click:close="mensagemErro = ''"
        class="mb-4"
      >
        {{ mensagemErro }}
      </v-alert>
      <v-alert
        v-if="mensagemSucesso"
        type="success"
        closable
        @click:close="mensagemSucesso = ''"
        class="mb-4"
      >
        {{ mensagemSucesso }}
      </v-alert>

      <fieldset
        :disabled="salvando"
        class="w-full border-none p-0 m-0"
        :key="modo"
      >
        <!-- Dados Básicos -->
        <v-card
          class="mb-6 rounded-xl shadow-sm border border-gray-100"
          elevation="0"
        >
          <v-card-text class="p-8">
            <h2 class="text-2xl font-semibold text-gray-800 mb-6">
              Dados Básicos do Formulário
            </h2>

            <v-row>
              <v-col cols="12" md="8">
                <p class="text-gray-700 font-medium mb-1">
                  Título do Formulário <span v-if="!isVisualizar">*</span>
                </p>
                <p
                  v-if="isVisualizar"
                  class="bg-gray-50 p-4 rounded-lg border border-gray-200"
                >
                  {{ formulario.titulo }}
                </p>
                <v-text-field
                  v-else
                  v-model="formulario.titulo"
                  placeholder="Ex: Avaliação de Protótipo de Alta Fidelidade"
                  variant="solo"
                  density="compact"
                  class="mt-2"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <p class="text-gray-700 font-medium mb-1">
                  Data de Definição <span v-if="!isVisualizar">*</span>
                </p>
                <p
                  v-if="isVisualizar"
                  class="bg-gray-50 p-4 rounded-lg border border-gray-200"
                >
                  {{ formatarDataParaExibicao(formulario.dataDefinicao) }}
                </p>
                <v-text-field
                  v-else
                  v-model="formulario.dataDefinicao"
                  type="date"
                  variant="solo"
                  density="compact"
                  class="mt-2"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <p class="text-gray-700 font-medium mb-1">
                  Descrição (TCLE) <span v-if="!isVisualizar">*</span>
                </p>
                <p
                  v-if="isVisualizar"
                  class="bg-gray-50 p-4 rounded-lg border border-gray-200 whitespace-pre-wrap"
                >
                  {{ formulario.descricaoTcle }}
                </p>
                <v-textarea
                  v-else
                  v-model="formulario.descricaoTcle"
                  placeholder="Este formulário tem como objetivo coletar avaliações dos usuários..."
                  variant="solo"
                  density="comfortable"
                  class="mt-2"
                  required
                  auto-grow
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <p class="text-gray-700 font-medium mb-1">
                  Explicação da Avaliação <span v-if="!isVisualizar">*</span>
                </p>
                <p
                  v-if="isVisualizar"
                  class="bg-gray-50 p-4 rounded-lg border border-gray-200 whitespace-pre-wrap"
                >
                  {{ formulario.explicacaoAvaliacao }}
                </p>
                <v-textarea
                  v-else
                  v-model="formulario.explicacaoAvaliacao"
                  placeholder="Instruções para quem for preencher o formulário..."
                  variant="solo"
                  density="comfortable"
                  class="mt-2"
                  required
                  auto-grow
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row v-if="!isVisualizar">
              <v-col cols="12">
                <v-switch
                  v-model="formulario.fl_ativo"
                  label="Formulário Ativo"
                  color="primary"
                  hide-details
                  inset
                  density="compact"
                  class="mt-2"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12">
                <p class="text-gray-700 font-medium mb-1">Status</p>
                <v-chip
                  :color="formulario.fl_ativo ? '#10B981' : '#EF4444'"
                  variant="tonal"
                  class="font-medium mt-1"
                >
                  {{ formulario.fl_ativo ? 'Ativo' : 'Inativo' }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Critérios de Avaliação -->
        <v-card
          class="mb-6 rounded-xl shadow-sm border border-gray-100"
          elevation="0"
        >
          <v-card-text class="p-8">
            <h2 class="text-2xl font-semibold text-gray-800 mb-6">
              Critérios de Avaliação
            </h2>

            <div class="flex justify-between items-center mb-4">
              <h3 class="text-lg font-medium text-gray-700">Objetivos</h3>
            </div>

            <div class="flex flex-col gap-4">
              <div
                v-for="(criterio, cIdx) in formulario.criterios"
                :key="criterio._uid"
                class="bg-gray-50/50 border border-gray-200 rounded-xl p-6 flex flex-col gap-4 shadow-sm"
              >
                <div class="flex justify-between items-center">
                  <h3 class="text-md font-semibold text-gray-600">
                    Critério #{{ cIdx + 1 }}
                  </h3>
                  <v-btn
                    v-if="!isVisualizar"
                    @click.prevent="removerCriterio(cIdx)"
                    icon="mdi-delete"
                    color="error"
                    variant="text"
                    size="small"
                    title="Remover Critério"
                  ></v-btn>
                </div>
                <v-row>
                  <v-col cols="12" md="6">
                    <p class="text-gray-700 font-medium mb-1">
                      Atributo de Qualidade Relacionado
                    </p>
                    <p
                      v-if="isVisualizar"
                      class="bg-white p-4 rounded-lg border border-gray-200"
                    >
                      {{
                        atributosQualidade.find(
                          (a) =>
                            a.id_atributo_qualidade ===
                            criterio.id_atributo_qualidade,
                        )?.nome || 'Nenhum'
                      }}
                    </p>
                    <v-select
                      v-else
                      v-model="criterio.id_atributo_qualidade"
                      :items="[
                        {
                          id_atributo_qualidade: null,
                          nome: 'Selecionar atributo',
                        },
                        ...atributosQualidade,
                      ]"
                      item-title="nome"
                      item-value="id_atributo_qualidade"
                      variant="solo"
                      density="compact"
                      class="mt-2"
                      hide-details="auto"
                      bg-color="white"
                    >
                      <template #selection="{ item }">
                        <span
                          :class="
                            item.value === null
                              ? 'text-gray-400'
                              : 'text-gray-900'
                          "
                        >
                          {{ item.title }}
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <p class="text-gray-700 font-medium mb-1">
                      Descrição do Critério <span v-if="!isVisualizar">*</span>
                    </p>
                    <p
                      v-if="isVisualizar"
                      class="bg-white p-4 rounded-lg border border-gray-200"
                    >
                      {{ criterio.descricao }}
                    </p>
                    <v-text-field
                      v-else
                      v-model="criterio.descricao"
                      placeholder="Ex: A navegação entre telas é intuitiva?"
                      variant="solo"
                      density="compact"
                      class="mt-2"
                      hide-details="auto"
                      bg-color="white"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <div
                  class="mt-4 bg-white p-5 rounded-lg border border-gray-200 shadow-sm"
                >
                  <div class="flex justify-between items-center mb-4">
                    <p class="text-gray-700 font-medium m-0 text-base">
                      Opções de Resposta
                    </p>
                    <v-btn
                      v-if="!isVisualizar"
                      @click.prevent="preencherEscala010(cIdx)"
                      color="primary"
                      variant="outlined"
                      size="x-small"
                      prepend-icon="mdi-numeric"
                      class="rounded-full font-semibold"
                    >
                      Escala de 0 a 10
                    </v-btn>
                  </div>

                  <div v-if="!isVisualizar" class="flex flex-col gap-3">
                    <div
                      v-for="(opcao, oIdx) in criterio.opcoes"
                      :key="opcao._uid"
                      class="flex items-center gap-3"
                    >
                      <v-text-field
                        v-model="opcao.descricao"
                        placeholder="Descrição (Ex: Excelente) *"
                        variant="solo"
                        density="compact"
                        hide-details
                        class="flex-1"
                      ></v-text-field>
                      <v-btn
                        @click.prevent="removerOpcao(cIdx, oIdx)"
                        icon="mdi-close"
                        color="error"
                        variant="text"
                        size="small"
                        class="flex-none"
                      ></v-btn>
                    </div>

                    <v-btn
                      @click.prevent="adicionarOpcao(cIdx)"
                      color="primary"
                      variant="text"
                      prepend-icon="mdi-plus-circle-outline"
                      size="small"
                      class="self-start mt-2 font-semibold"
                    >
                      Adicionar nova opção
                    </v-btn>
                  </div>

                  <div v-else class="flex flex-col gap-2">
                    <div
                      v-for="(opcao, oIdx) in criterio.opcoes"
                      :key="oIdx"
                      class="flex justify-between items-center bg-gray-50 px-4 py-3 rounded-lg border border-gray-100"
                    >
                      <span class="text-sm text-gray-700">{{
                        opcao.descricao
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!isVisualizar" class="flex justify-end mt-4 mb-6">
              <v-btn
                @click.prevent="adicionarCriterio"
                color="primary"
                variant="outlined"
                prepend-icon="mdi-plus"
                size="small"
                class="rounded-full"
              >
                Adicionar critério
              </v-btn>
            </div>

            <!-- Perguntas Subjetivas -->
            <div class="flex justify-between items-center mt-10 mb-4">
              <h3 class="text-lg font-medium text-gray-700">Subjetivos</h3>
              <v-btn
                v-if="!isVisualizar"
                @click.prevent="adicionarCriterioSubjetivo"
                color="primary"
                variant="outlined"
                prepend-icon="mdi-plus"
                size="small"
                class="rounded-full"
              >
                Adicionar pergunta
              </v-btn>
            </div>

            <div class="flex flex-col gap-4">
              <div
                v-for="(criterio, cIdx) in formulario.criteriosSubjetivos"
                :key="criterio._uid"
                class="bg-gray-50/50 border border-gray-200 rounded-xl p-6 flex flex-col gap-4 shadow-sm"
              >
                <div class="flex justify-between items-center">
                  <h3 class="text-md font-semibold text-gray-600">
                    Pergunta #{{ cIdx + 1 }}
                  </h3>
                  <v-btn
                    v-if="!isVisualizar"
                    @click.prevent="removerCriterioSubjetivo(cIdx)"
                    icon="mdi-delete"
                    color="error"
                    variant="text"
                    size="small"
                    title="Remover Pergunta"
                  ></v-btn>
                </div>

                <v-row>
                  <v-col cols="12">
                    <p class="text-gray-700 font-medium mb-1">
                      Descrição da Pergunta <span v-if="!isVisualizar">*</span>
                    </p>
                    <p
                      v-if="isVisualizar"
                      class="bg-white p-4 rounded-lg border border-gray-200"
                    >
                      {{ criterio.descricao }}
                    </p>
                    <v-text-field
                      v-else
                      v-model="criterio.descricao"
                      placeholder="Ex: O que você achou da paleta de cores?"
                      variant="solo"
                      density="compact"
                      class="mt-2"
                      hide-details="auto"
                      bg-color="white"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </fieldset>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  name: 'FormularioValidacao',
  data() {
    const tzOffset = new Date().getTimezoneOffset() * 60000;
    const localISODate = new Date(Date.now() - tzOffset)
      .toISOString()
      .slice(0, 10);

    return {
      carregando: false,
      salvando: false,
      atributosQualidade: [],
      modo: 'criar',
      idFormulario: null,
      mensagemErro: '',
      mensagemSucesso: '',
      formulario: {
        titulo: '',
        dataDefinicao: localISODate,
        descricaoTcle: '',
        explicacaoAvaliacao: '',
        // eslint-disable-next-line camelcase
        fl_ativo: true,
        criterios: [
          {
            _uid: this.gerarUID(),
            descricao: '',
            // eslint-disable-next-line camelcase
            id_atributo_qualidade: null,
            opcoes: [{ _uid: this.gerarUID(), descricao: '', pontuacao: 0 }],
          },
        ],
        criteriosSubjetivos: [
          {
            _uid: this.gerarUID(),
            descricao: '',
          },
        ],
      },
    };
  },
  computed: {
    isCriar() {
      return this.modo === 'criar';
    },
    isVisualizar() {
      return this.modo === 'visualizar';
    },
    isEditar() {
      return this.modo === 'editar';
    },
    tituloPagina() {
      if (this.isCriar) {
        return 'Criar Formulário de Validação';
      }
      if (this.isVisualizar) {
        return 'Detalhes do Formulário de Validação';
      }

      return 'Editar Formulário de Validação';
    },
  },
  mounted() {
    this.carregarAtributosQualidade();
    this.idFormulario = this.$route.params.id;
    if (this.idFormulario) {
      this.modo = this.$route.query.mode === 'edit' ? 'editar' : 'visualizar';
      this.carregarFormulario();
    }
  },
  methods: {
    gerarUID() {
      return Date.now().toString() + Math.random().toString(36).slice(2, 7);
    },
    async carregarAtributosQualidade() {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `${API_URL}/api/v1/atributoQualidade`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        this.atributosQualidade = response.data;
      } catch (error) {
        console.error('Erro ao carregar atributos de qualidade', error);
      }
    },
    async carregarFormulario() {
      this.carregando = true;
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `${API_URL}/api/v1/formularioValidacao/${this.idFormulario}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        const dadosRetornados = response.data;

        let dataFormatada = '';
        if (dadosRetornados.data_definicao) {
          dataFormatada = dadosRetornados.data_definicao.slice(0, 10);
        }

        this.formulario = {
          titulo: dadosRetornados.titulo,
          dataDefinicao: dataFormatada,
          descricaoTcle:
            dadosRetornados.descricao_tcle || dadosRetornados.descricaoTcle,
          explicacaoAvaliacao:
            dadosRetornados.explicacao_avaliacao ||
            dadosRetornados.explicacaoAvaliacao,
          // eslint-disable-next-line camelcase
          fl_ativo:
            dadosRetornados.fl_ativo !== undefined
              ? dadosRetornados.fl_ativo
              : true,
          criterios: (dadosRetornados.tb_criterio_objetivo || []).map(
            (criterio) => ({
              _uid: this.gerarUID(),
              // eslint-disable-next-line camelcase
              id_criterio_objetivo: criterio.id_criterio_objetivo,
              descricao: criterio.descricao,
              // eslint-disable-next-line camelcase
              id_atributo_qualidade: criterio.id_atributo_qualidade || null,
              opcoes: (criterio.tb_opcao_criterio_objetivo || []).map(
                (opcao) => ({
                  _uid: this.gerarUID(),
                  // eslint-disable-next-line camelcase
                  id_opcao_criterio: opcao.id_opcao_criterio,
                  descricao: opcao.descricao,
                  pontuacao: opcao.pontuacao,
                }),
              ),
            }),
          ),
          criteriosSubjetivos: dadosRetornados.tb_avaliacao_subjetiva
            ? dadosRetornados.tb_avaliacao_subjetiva.map((criterio) => ({
                _uid: this.gerarUID(),
                // eslint-disable-next-line camelcase
                id_avaliacao_subjetiva: criterio.id_avaliacao_subjetiva,
                descricao: criterio.descricao_para_avaliacao,
              }))
            : [],
        };
      } catch (error) {
        console.error('[carregarFormulario] Erro ao buscar formulário:', error);
        console.error(
          '[carregarFormulario] Status HTTP:',
          error?.response?.status,
        );
        console.error(
          '[carregarFormulario] Dados do erro:',
          error?.response?.data,
        );
        this.mensagemErro =
          'Não foi possível carregar os dados deste formulário.';
      } finally {
        this.carregando = false;
      }
    },
    alternarParaEdicao() {
      this.modo = 'editar';
      this.mensagemErro = '';
      this.mensagemSucesso = '';
      this.$router.replace({ query: { mode: 'edit' } }).catch(() => {});
    },
    formatarDataParaExibicao(dataString) {
      if (!dataString) {
        return '';
      }
      const parts = dataString.split('T')[0].split('-');
      if (parts.length === 3) {
        const [ano, mes, dia] = parts;

        return `${dia}/${mes}/${ano}`;
      }

      return dataString;
    },
    adicionarCriterio() {
      this.formulario.criterios.push({
        _uid: this.gerarUID(),
        descricao: '',
        // eslint-disable-next-line camelcase
        id_atributo_qualidade: null,
        opcoes: [{ _uid: this.gerarUID(), descricao: '', pontuacao: 0 }],
      });
    },
    removerCriterio(index) {
      this.formulario.criterios.splice(index, 1);
    },
    adicionarCriterioSubjetivo() {
      this.formulario.criteriosSubjetivos.push({
        _uid: this.gerarUID(),
        descricao: '',
      });
    },
    removerCriterioSubjetivo(index) {
      this.formulario.criteriosSubjetivos.splice(index, 1);
    },
    adicionarOpcao(criterioIndex) {
      this.formulario.criterios[criterioIndex].opcoes.push({
        _uid: this.gerarUID(),
        descricao: '',
        pontuacao: 0,
      });
    },
    removerOpcao(criterioIndex, opcaoIndex) {
      this.formulario.criterios[criterioIndex].opcoes.splice(opcaoIndex, 1);
    },
    preencherEscala010(criterioIndex) {
      const opcoes = [];
      for (let i = 0; i <= 10; i++) {
        opcoes.push({
          _uid: this.gerarUID(),
          descricao: String(i),
          pontuacao: i,
        });
      }
      this.formulario.criterios[criterioIndex].opcoes = opcoes;
    },
    validarPayload() {
      if (!this.formulario.titulo || this.formulario.titulo.trim() === '') {
        this.mensagemErro = 'O título do formulário é obrigatório.';

        return false;
      }
      if (!this.formulario.dataDefinicao) {
        this.mensagemErro = 'A data de definição é obrigatória.';

        return false;
      }
      if (
        !this.formulario.descricaoTcle ||
        this.formulario.descricaoTcle.trim() === ''
      ) {
        this.mensagemErro = 'A descrição do TCLE não pode ficar vazia.';

        return false;
      }
      if (
        !this.formulario.explicacaoAvaliacao ||
        this.formulario.explicacaoAvaliacao.trim() === ''
      ) {
        this.mensagemErro = 'A explicação da avaliação é obrigatória.';

        return false;
      }

      if (this.isCriar || this.isEditar) {
        if (this.formulario.criterios.length === 0) {
          this.mensagemErro =
            'O formulário deve possuir pelo menos um critério objetivo.';

          return false;
        }
        for (let i = 0; i < this.formulario.criterios.length; i++) {
          const crit = this.formulario.criterios[i];
          if (!crit.descricao || crit.descricao.trim() === '') {
            this.mensagemErro = `O critério objetivo #${
              i + 1
            } possui descrição inválida.`;

            return false;
          }
          if (crit.opcoes.length === 0) {
            this.mensagemErro = `O critério objetivo #${
              i + 1
            } deve ter pelo menos uma opção de resposta.`;

            return false;
          }
          for (let j = 0; j < crit.opcoes.length; j++) {
            const opt = crit.opcoes[j];
            if (!opt.descricao || opt.descricao.trim() === '') {
              this.mensagemErro = `A opção #${j + 1} do critério objetivo #${
                i + 1
              } possui descrição inválida.`;

              return false;
            }
          }
        }

        if (this.formulario.criteriosSubjetivos.length === 0) {
          this.mensagemErro =
            'O formulário deve possuir pelo menos uma pergunta subjetiva.';

          return false;
        }
        for (let i = 0; i < this.formulario.criteriosSubjetivos.length; i++) {
          const critSub = this.formulario.criteriosSubjetivos[i];
          if (!critSub.descricao || critSub.descricao.trim() === '') {
            this.mensagemErro = `A pergunta subjetiva #${
              i + 1
            } possui descrição inválida.`;

            return false;
          }
        }
      }

      return true;
    },
    async salvar() {
      this.mensagemErro = '';
      this.mensagemSucesso = '';

      if (!this.validarPayload()) {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        return;
      }

      this.salvando = true;

      try {
        let payloadDataDefinicao = '';
        if (this.formulario.dataDefinicao) {
          const dtParts = this.formulario.dataDefinicao.split('-');
          if (dtParts.length === 3) {
            payloadDataDefinicao = new Date(
              dtParts[0],
              dtParts[1] - 1,
              dtParts[2],
            ).toISOString();
          } else {
            payloadDataDefinicao = new Date(
              this.formulario.dataDefinicao,
            ).toISOString();
          }
        }

        const payloadData = {
          titulo: this.formulario.titulo,
          // eslint-disable-next-line camelcase
          data_definicao: payloadDataDefinicao,
          // eslint-disable-next-line camelcase
          descricao_tcle: this.formulario.descricaoTcle,
          // eslint-disable-next-line camelcase
          explicacao_avaliacao: this.formulario.explicacaoAvaliacao,
          // eslint-disable-next-line camelcase
          fl_ativo: this.formulario.fl_ativo,
        };

        const token = localStorage.getItem('token');

        if (this.isCriar) {
          payloadData.criterios = this.formulario.criterios.map((c) => ({
            descricao: c.descricao,
            // eslint-disable-next-line camelcase
            id_atributo_qualidade: c.id_atributo_qualidade,
            opcoes: c.opcoes.map((o) => ({
              descricao: o.descricao,
              pontuacao: o.pontuacao,
            })),
          }));
          payloadData.criteriosSubjetivos =
            this.formulario.criteriosSubjetivos.map((c) => ({
              descricao: c.descricao,
            }));

          const response = await axios.post(
            `${API_URL}/api/v1/formularioValidacao`,
            payloadData,
            { headers: { Authorization: `Bearer ${token}` } },
          );

          this.mensagemSucesso =
            'Formulário criado com sucesso! Redirecionando...';
          window.scrollTo({ top: 0, behavior: 'smooth' });

          const newId =
            response.data?.id_formulario_validacao || response.data?.id || '';

          setTimeout(() => {
            this.voltar(newId);
          }, 1500);
        } else if (this.isEditar) {
          payloadData.criterios = this.formulario.criterios.map((c) => ({
            // eslint-disable-next-line camelcase
            id_criterio_objetivo: c.id_criterio_objetivo,
            descricao: c.descricao,
            // eslint-disable-next-line camelcase
            id_atributo_qualidade: c.id_atributo_qualidade,
            opcoes: c.opcoes.map((o) => ({
              // eslint-disable-next-line camelcase
              id_opcao_criterio: o.id_opcao_criterio,
              descricao: o.descricao,
              pontuacao: o.pontuacao,
            })),
          }));
          payloadData.criteriosSubjetivos =
            this.formulario.criteriosSubjetivos.map((c) => ({
              // eslint-disable-next-line camelcase
              id_avaliacao_subjetiva: c.id_avaliacao_subjetiva,
              descricao: c.descricao,
            }));

          await axios.put(
            `${API_URL}/api/v1/formularioValidacao/${this.idFormulario}`,
            payloadData,
            { headers: { Authorization: `Bearer ${token}` } },
          );

          this.mensagemSucesso = 'Formulário atualizado com sucesso!';
          window.scrollTo({ top: 0, behavior: 'smooth' });

          this.modo = 'visualizar';
          this.$router.replace({ query: { mode: 'view' } }).catch(() => {});
          await this.carregarFormulario();
        }
      } catch (error) {
        console.error('[salvar] Erro ao salvar formulário:', error);
        if (error.response) {
          console.error(
            '[salvar] Resposta de erro do servidor:',
            error.response.data,
          );
        }
        this.mensagemErro =
          error.response?.data?.error ||
          'Ocorreu um erro ao tentar salvar o formulário no servidor.';
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } finally {
        this.salvando = false;
      }
    },
    voltar(newFormId = null) {
      if (this.$route.query.origin) {
        this.$router.push({
          path: this.$route.query.origin,
          query: newFormId ? { newFormId } : {},
        });
      } else {
        this.$router.push('/gestao-formularios-validacao');
      }
    },
  },
};
</script>
